// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// function to sort creneau by date/time
export default function creneauxSorter(creneau1, creneau2) {

    
    if (dayjs(creneau1.creneau.date).isSame(dayjs(creneau2.creneau.date), 'day')) { // creneau 1 & 2 on same day
        if (creneau1.creneau.horaire > creneau2.creneau.horaire) {
            return (1);
        }
        else // same day but creneau 1 later than creneau 2
        {
            return (-1)
        }
    }

    else { // Creneau 1 & 2 on different days
        if (dayjs(creneau1.creneau.date).isAfter(dayjs(creneau2.creneau.date), 'day')) {
            return (1);
        }
        else {
            return (-1)
        }
    }
}

export function creneauxSorter2(creneau1, creneau2) {

    
    if (dayjs(creneau1.date).isSame(dayjs(creneau2.date), 'day')) { // creneau 1 & 2 on same day
        if (creneau1.horaire > creneau2.horaire) {
            return (1);
        }
        else // same day but creneau 1 later than creneau 2
        {
            return (-1)
        }
    }

    else { // Creneau 1 & 2 on different days
        if (dayjs(creneau1.date).isAfter(dayjs(creneau2.date), 'day')) {
            return (1);
        }
        else {
            return (-1)
        }
    }
}

export function creneauxSorter3(date1, date2) {

    
    if (dayjs(date1).isSame(dayjs(date2), 'day')) { // creneau 1 & 2 on same day
       
            return (0);
        
    }

    else { // Creneau 1 & 2 on different days
        if (dayjs(date1).isAfter(dayjs(date2), 'day')) {
            return (1);
        }
        else {
            return (-1)
        }
    }
}